import React, { useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import SingleContactDetails from './single-contact-details'
import { SolidButton, TransparentButton } from '../../../../library/button'
import { changeSingleContactListModal, requestAddSingleRecord } from '../../../../../redux/actions/single-contact-list'
import { auth } from '../../../../../networking/firebase'
import { Popup } from '../../../../library/popup'
import './style.scss'

const Index = props => {

    const dispatch = useDispatch()

    const listId = props.match.params.id

    const addLoading = useSelector(state => state.singleContactList.addSingleRecord.loading)
    const modalState = useSelector(state => state.singleContactList.showModals.addSingleModal)

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

    const [singleContact, setSingleContact] = useState({
        addedBy: auth.currentUser.uid,
		logoUrl: null,
		general: {
			firstName: null,
			lastName: null
		},
		contact: {
			phone: null,
			email: null,
			website: null
		},
        company:{
            name: null,
            position: null
        },
		social: {
			twitter: null,
			facebook: null
		},
		address: {
			street: null,
			postalCode: null,
			city: null,
			country: null
		},
    })

    const handleClose = () => {
        dispatch(changeSingleContactListModal({addSingleModal: false}))
    }

    const clickAddContact = () => {
       dispatch(requestAddSingleRecord({companyId: selectedCompany, id: listId, record: singleContact}))
    }

	return(
		<Popup
			onClose={handleClose}
            show={modalState} 
            title="Legg til ny kontakt"
            description="Legg til en ny kontakt gjennom skjemaet under, og fyll inn all informasjon du har om vedkommende."
            buttons={[
                <TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
                <SolidButton color="blue" title={addLoading ? "Legger til..":"Legg til"} onClick={() => clickAddContact()} icon={addLoading ? <i className="fas fa-circle-notch fa-spin"></i>:<i className="fas fa-plus"></i>} type="button"/>
            ]}	
		>
			<div className="add-single-content-container">
				<SingleContactDetails singleContact={singleContact} setSingleContact={setSingleContact}/>
			</div>
			<ToastContainer/>
		</Popup>
	)
}

export default withRouter(Index)